// Unpublished Work © 2020-2023 Deere & Company

import React from 'react';
import ReactDOM from 'react-dom';
import {RoutesProvider} from './routes-provider';
import './index.css';

ReactDOM.render(
    <RoutesProvider/>,
    globalThis.document.querySelector('#ui-core')
);
